import React from "react";

const Chapter4 = () => {
  return (
    <>
      <h2>
        How does <em>E. coli</em> get into the South Platte River?
      </h2>
      <img
        style={{ width: "80%", margin: "20px auto" }}
        alt="ecoli source"
        src="/static/img/storylines/ecoli_source-02.png"
      />

      <p>
        <em>E. coli</em> and other fecal contaminants can enter the river from
        broken sewer lines, on-site septic systems, direct discharge of waste
        from domestic and wild animals, and storm runoff.
      </p>

      <p>
        Denver Metro-area lakes and streams receive runoff from city streets,
        yards, and parks as well as discharges from industry and wastewater
        treatment plants. Some agricultural practices such as spreading manure
        on fields and allowing livestock watering in streams can contribute to{" "}
        <em>E. coli</em> contamination.
      </p>
    </>
  );
};

export default Chapter4;
